import { instancePath } from "./instance";

export type McpConnection = { id: string; client_name: string; scope: string; created_at: string; project_ids: string[] };
export type McpAction = { id: string; client_name: string; tool: string; title: string | null; url: string | null; created_at: string; completed_at: string | null; failed: boolean };
export type McpSettings = { enabled: boolean; url: string; connections: McpConnection[]; actions: McpAction[] };
export type McpTeam = { instance_id: string | null; id: string; name: string; slug: string; projects: { id: string; name: string; key: string; role: string | null }[] };
export type McpConsent = { client_name: string; redirect_host: string; scope: string; teams: McpTeam[]; email: string };
export async function mcpRequest<T>(path: string, body?: unknown, method = "GET", root = false): Promise<T> {
  const response = await fetch(`${root ? "" : instancePath}/api/${path}`, {
    method, credentials: "same-origin", headers: { "Content-Type": "application/json" },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => null) as { message?: string } | null;
    throw new Error(error?.message ?? `Request failed (${response.status})`);
  }
  return response.status === 204 ? undefined as T : response.json() as Promise<T>;
}
